import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next/';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import GraphQL from '../../GraphQL';
import Modal from '../../shared/components/Modal';
import Sidebar from './sidebar/Sidebar';
import SmartContext from '../App/context/SmartContext';
import { clearAuth, domainSchool } from '../../auth';
import {
  changeThemeToDark,
  changeThemeToLight,
} from '../../redux/actions/themeActions';
import { changeMobileSidebarVisibility } from '../../redux/actions/sidebarActions';
import { SidebarProps } from '../../shared/prop-types/ReducerProps';
import { schoolTermEmployeeRelationshipForLoggedUser } from '../../shared/queries/SchoolTermEmployeeRelation';
import changeSchoolTermList from '../../redux/actions/schoolTermActions';
import accessListByLoggedUser from '../../shared/queries/Access';
import Survey from './components/Survey';
import ModalForm from '../../shared/components/ModalForm';
import surveyAnswerSave from '../../shared/queries/SurveyAnswer';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';

const Layout = (props) => {
  const [openSurveyModal, setOpenSurveyModal] = useState(false);
  const [accessListByUser, setAccessListByUser] = useState({
    loggedUser: {},
    listOfPermission: [],
    listOfOperation: [],
  });
  const { dispatch, history, t } = props;
  const { sidebar } = props;
  const layoutClass = classNames({
    layout: true,
    'layout--collapse': sidebar.collapse,
  });

  const context = useContext(SmartContext);
  const {
    setLoggedUser,
    logginOut,
    toggleLoginOut,
    setlistOfPermission,
    setListOfOperation,
    cleanContext,
    survey,
    setSurvey,
    filesToUpload,
  } = context;

  function toggleOpenSurveyModal() {
    setOpenSurveyModal(!openSurveyModal);
  }

  function updateSchoolTermList(list) {
    dispatch(changeSchoolTermList(list));
  }

  function verifySurvey() {
    if (survey && !survey.deny) {
      toggleOpenSurveyModal();
    }
  }

  function denySurvey() {
    setSurvey(null);
    toggleOpenSurveyModal();
  }

  function loadAccessList() {
    const accessDataQuery = accessListByLoggedUser();
    GraphQL(accessDataQuery, {})
      .then((res) => {
        const { loggedUser, listOfPermission, listOfOperation } =
          res.accessListByUser;
        setAccessListByUser(res.accessListByUser);
        setLoggedUser(loggedUser);
        setlistOfPermission(listOfPermission);
        setListOfOperation(listOfOperation);
        domainSchool(loggedUser.clientSchema);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function loadTerms() {
    const terms = schoolTermEmployeeRelationshipForLoggedUser();
    GraphQL(terms, {})
      .then((res) => {
        res.schoolTermEmployeeRelationshipForLoggedUser =
          res.schoolTermEmployeeRelationshipForLoggedUser.filter(
            (item) => item.id > 0
          );
        res.schoolTermEmployeeRelationshipForLoggedUser =
          res.schoolTermEmployeeRelationshipForLoggedUser.map((item) => ({
            id: item.schoolTerm.id,
            name: item.schoolTerm.name,
            value: item.schoolTerm.id,
            label: item.schoolTerm.name,
          }));
        updateSchoolTermList(res.schoolTermEmployeeRelationshipForLoggedUser);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function submitSurveyAnswer(values) {
    const mutation = surveyAnswerSave(values);
    toggleOpenSurveyModal();
    setSurvey(null);
    GraphQL(mutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  }

  const changeMobileSidebarVisibilityHandler = () => {
    dispatch(changeMobileSidebarVisibility());
  };

  const changeToDark = () => {
    dispatch(changeThemeToDark());
  };

  const changeToLight = () => {
    dispatch(changeThemeToLight());
  };

  const showUnLoad = () => {
    let show = null;
    if (filesToUpload.length) {
      show = true;
    }
    window.onbeforeunload = () => show;
    return show;
  };

  const confirmLogOut = () => {
    if (!showUnLoad()) {
      clearAuth();
      cleanContext();
      toggleLoginOut();
      history.push('/minime/login');
    } else {
      window.location.reload();
    }
  };

  useEffect(() => {
    verifySurvey();
  }, [survey]);

  useEffect(() => {
    loadAccessList();
    loadTerms();
  }, []);

  useEffect(() => {
    showUnLoad();
  }, [filesToUpload]);

  return (
    <div className={layoutClass}>
      {openSurveyModal && (
        <ModalForm
          close={denySurvey}
          isOpen={openSurveyModal}
          formBuilder={<Survey survey={survey} onSubmit={submitSurveyAnswer} />}
        />
      )}
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('general.exit-confirmation')}
        toggle={toggleLoginOut}
        modal={logginOut}
        onConfirm={confirmLogOut}
      />
      <Sidebar
        sidebar={sidebar}
        changeToDark={changeToDark}
        changeToLight={changeToLight}
        changeMobileSidebarVisibility={changeMobileSidebarVisibilityHandler}
        listOfPermission={accessListByUser.listOfPermission}
        loggedUser={accessListByUser.loggedUser}
        listOfOperation={accessListByUser.listOfOperation}
      />
    </div>
  );
};

Layout.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sidebar: SidebarProps.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  withRouter(
    connect((state) => ({
      sidebar: state.sidebar,
    }))(Layout)
  )
);
